import React, { createContext, useContext } from 'react';
import UseFetchStoreInfoQuery from '../../lib/reactQueryQueries/queries/useFetchStoreInfoQuery';

const PermissionsContext = createContext({});

export function PermissionsProvider({ children }) {
  const { data } = UseFetchStoreInfoQuery();
  const permissions = data?.data?.privacy?.permissions ?? {};
  return (
    <PermissionsContext.Provider value={permissions}>
      {children}
    </PermissionsContext.Provider>
  );
}

export const usePermissionsContext = () => useContext(PermissionsContext);
